// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"8b83fe90","937":"60e0c811"}[chunkId] + ".chunk.js";
};